import React from "react";
import DataGrid from "../DataGrid/DataGrid";
import { userContext } from "../Menu/MenuPicker";

interface Props {
  Title: string;
  MaxRows: number;
}

interface State {
  renderCount: number;
  user: any;
}

class SizeGrid extends React.Component<Props, State> {
  static contextType = userContext;
  constructor(props: Props) {
    super(props);
    this.state = {
      renderCount: 0,
      user: {},
    };
  }

  buildColumns(): any {
    const columnHeaders = [
      {
        DataPropertyName: "SizeId",
        IsIdColumn: true,
        ShowColumn: false,
      },
      {
        DataPropertyName: "SizeValue",
        ColumnAliasName: "Size (cm)",
        InputType: "text",
        ShowColumn: true,
        CanEdit: true,
      },
      {
        DataPropertyName: "",
        ColumnAliasName: "Actions",
        ShowColumn: true,
        IsActionsColumn: true,
      },
    ] as any;

    return columnHeaders;
  }

  componentDidMount(): void {
    let context: any = this.context;
    this.setState({ user: context.user });
  }

  render() {
    return (
      <div className="wrapper">
        <div className="section latest-offers">
          <div className="container">
            <h3 className="section-title">{this.props.Title}</h3>
            <hr />
            <DataGrid
              key={"dataGrid_" + this.state.renderCount}
              ColumnArray={this.buildColumns()}
              SelectAPI="Painting/GetAllSizes"
              UpdateAPI="Admin/UpdateSize"
              MaxNumberOfRowsPerPage={this.props.MaxRows}
              GridName="sizeValues"
              PrimaryKeyName="SizeId"
              LoadOnScroll={false}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default SizeGrid;
